import React, {
  useEffect,
  useRef,
  Suspense,
  useCallback,
  RefObject,
} from 'react';
import styled from '@emotion/styled';
import { designTokens } from '@platform-ui/design-system';
import { NAV_WIDTH } from './constants/index';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import TrainingCenterButton from './TrainingCenterButton';

const LazyDrawerInner = React.lazy(() => import('./DrawerInner'));

const DrawerRoot = styled.div`
  width: ${NAV_WIDTH};
  min-width: ${NAV_WIDTH};
  display: inline-block;
  transition: all 200ms;
  position: relative;
  background-color: ${designTokens.colors.darkMainContainer};
`;

const DrawerRootInner = styled.div`
  position: sticky;
  top: 0;
  overflow-y: auto;
  background-color: ${designTokens.colors.darkMainContainer};

  &:before,
  &:after {
    content: '';
    display: table;
  }
`;

interface DrawerProps {
  drawerOpen: boolean;
  navHeaderRef?: RefObject<HTMLElement>;
}

export const Drawer = ({ drawerOpen, navHeaderRef }: DrawerProps) => {
  const root = useRef<HTMLDivElement>(null);
  const rootInner = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (root.current) {
      const marginLeft = drawerOpen ? '0' : `-${NAV_WIDTH}`;
      root.current.style.marginLeft = marginLeft;
    }
  }, [drawerOpen]);

  const setDrawerHeight = useCallback(() => {
    if (navHeaderRef?.current && rootInner.current) {
      const rect = navHeaderRef.current.getBoundingClientRect();
      const newHeight = `calc(100vh - ${rect.height}px)`;
      rootInner.current.style.height = newHeight;
      rootInner.current.style.top = `${rect.height}px`;
    }
  }, [navHeaderRef?.current, rootInner.current]);

  useScrollPosition(setDrawerHeight, [], undefined, true);

  return (
    <DrawerRoot id="nav-v2-drawer-root" ref={root} aria-hidden={!drawerOpen}>
      <DrawerRootInner ref={rootInner}>
        <Suspense fallback={<React.Fragment />}>
          <LazyDrawerInner {...{ drawerOpen, onLoaded: setDrawerHeight }} />
        </Suspense>
      </DrawerRootInner>
      <TrainingCenterButton />
    </DrawerRoot>
  );
};
